import { defineStore } from 'pinia'

export const useWechatStore = defineStore({
  id: 'myUseWeChatStore',
  state: () => ({
    // 本地缓存置业顾问信息，微聊聊过的
    adviser: {} as any,
  }),
  getters: {
    getAdviser(state) {
      return (floorId: number) => state.adviser[floorId] || null
    },
  },
  actions: {
    // 设置置业顾问缓存
    setAdviser(obj: any) {
      this.adviser = Object.assign({}, this.adviser, obj || {})
    },
    // 清除置业顾问缓存
    clearAdviser() {
      this.adviser = null
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
})
